import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { ILoaderState } from "../_models/ILoaderState";

@Injectable({ providedIn: "root" })
export class LoaderService {

    private loaderSubject = new Subject<ILoaderState>();

    loaderState = this.loaderSubject.asObservable();

    show() {
        setTimeout(() => {
            this.loaderSubject.next({ show: true } as ILoaderState);
        }, 500);
    }

    hide() {
        setTimeout(() => {
            this.loaderSubject.next({ show: false } as ILoaderState);
        }, 500);
    }
}